import React from "react";
import { Avatar, AvatarImage, AvatarFallback } from "../ui/avatar";
import { useThemeContext } from "../../context/DarkMode";
import { getPublicFileUrl } from "../../config";

export const WHATSAPP_LIGHT = {
	bgChat: "#efeae2",
	bgChatDots:
		"url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='400' height='400' viewBox='0 0 400 400'><g fill='%23000000' fill-opacity='0.028'><circle cx='120' cy='120' r='1.5'/><circle cx='280' cy='80' r='1.5'/><circle cx='360' cy='200' r='1.5'/><circle cx='60' cy='300' r='1.5'/><circle cx='200' cy='360' r='1.5'/><circle cx='320' cy='320' r='1.5'/></g></svg>\")",
	balaoEnviada: "#d9fdd3",
	balaoRecebida: "#ffffff",
	corTextoEnviada: "#111b21",
	corTextoRecebida: "#111b21",
	corTimeEnviada: "#667781",
	corTimeRecebida: "#667781",
	verdeWpp: "#00a884",
	verdeWppEscuro: "#008069",
	nomeAutorGrupo: "#111b21",
	bgSidebar: "#ffffff",
	bgHeader: "#f0f2f5",
	bgInput: "#f0f2f5",
	bgQuotedEnviada: "#c9f4c6",
	bgQuotedRecebida: "#f0f2f5",
	borderQuoted: "#00a884",
	borderQuotedMinha: "#008069",
	bgChipReaction: "rgba(255,255,255,0.8)",
	bgChipReactionMinha: "rgba(255,255,255,0.9)",
	bgChipReactionEu: "#e8f4ee",
	bgChipReactionEuMinha: "#e9f3f0",
	bgSidebarItemSelected: "#f0f2f5",
	bgSidebarHover: "#f5f6f6",
	bgSidebarSeparator: "#f0f2f5",
	textoMuted: "#667781",
	badgeUnread: "#00a884",
	borderSeparator: "#e9edef",
	bgEmptyChat: "#f0f2f5",
	popoverBg: "#ffffff",
	popoverBorder: "#e9edef",
	avatarBgGrupo: "#d1f4cc",
	avatarBgPessoa: "#e3f0da",
	avatarIconColor: "#008069",
	barraResponderBg: "#ffffff",
	chipAnexoBg: "#ffffff",
	inputBg: "#ffffff",
};

export const WHATSAPP_DARK = {
	bgChat: "#0b141a",
	bgChatDots:
		"url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='400' height='400' viewBox='0 0 400 400'><g fill='%23ffffff' fill-opacity='0.04'><circle cx='120' cy='120' r='1.5'/><circle cx='280' cy='80' r='1.5'/><circle cx='360' cy='200' r='1.5'/><circle cx='60' cy='300' r='1.5'/><circle cx='200' cy='360' r='1.5'/><circle cx='320' cy='320' r='1.5'/></g></svg>\")",
	balaoEnviada: "#005c4b",
	balaoRecebida: "#202c33",
	corTextoEnviada: "#e9edef",
	corTextoRecebida: "#e9edef",
	corTimeEnviada: "#8696a0",
	corTimeRecebida: "#8696a0",
	verdeWpp: "#00a884",
	verdeWppEscuro: "#00cf8c",
	nomeAutorGrupo: "#e9edef",
	bgSidebar: "#111b21",
	bgHeader: "#202c33",
	bgInput: "#202c33",
	bgQuotedEnviada: "#0a4c3e",
	bgQuotedRecebida: "#2b373d",
	borderQuoted: "#00a884",
	borderQuotedMinha: "#53bdeb",
	bgChipReaction: "rgba(32,44,51,0.92)",
	bgChipReactionMinha: "rgba(0,92,75,0.92)",
	bgChipReactionEu: "#17423b",
	bgChipReactionEuMinha: "#0b624f",
	bgSidebarItemSelected: "#2a3942",
	bgSidebarHover: "#202c33",
	bgSidebarSeparator: "#233138",
	textoMuted: "#8696a0",
	badgeUnread: "#00a884",
	borderSeparator: "#233138",
	bgEmptyChat: "#222e35",
	popoverBg: "#233138",
	popoverBorder: "#1c2b33",
	avatarBgGrupo: "#175c49",
	avatarBgPessoa: "#2c3d37",
	avatarIconColor: "#00cf8c",
	barraResponderBg: "#202c33",
	chipAnexoBg: "#2a3942",
	inputBg: "#2a3942",
};

export const getInitials = (name) => {
	if (!name) return "??";
	const clean = String(name).trim();
	if (!clean) return "??";
	const parts = clean.split(/\s+/).filter(Boolean);
	if (parts.length === 0) return clean.slice(0, 2).toUpperCase();
	if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
	return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

export const AvatarUsuario = ({
	user = null,
	name = "",
	profilePicUrl = null,
	size = "md",
	className = "",
}) => {
	const { darkMode } = useThemeContext();
	const tema = darkMode ? WHATSAPP_DARK : WHATSAPP_LIGHT;
	const url = user?.profilePicUrl || profilePicUrl;
	const nomeMostrar = user?.name || name || "?";
	const tamanhos = {
		sm: "h-6 w-6 text-[10px]",
		md: "h-10 w-10 text-xs",
		lg: "h-9 w-9 text-xs",
	};
	const dimensao = tamanhos[size] || tamanhos.md;
	const publicUrl = url ? getPublicFileUrl(url) : undefined;
	return (
		<Avatar className={`${dimensao} shrink-0 ${className}`}>
			{publicUrl ? (
				<AvatarImage src={publicUrl} alt={nomeMostrar} referrerPolicy="no-referrer" />
			) : null}
			<AvatarFallback
				className={`${dimensao.replace(/h-\d+ w-\d+ /, "")} font-semibold`}
				style={{
					backgroundColor: tema.avatarBgPessoa,
					color: tema.avatarIconColor,
				}}
			>
				{getInitials(nomeMostrar)}
			</AvatarFallback>
		</Avatar>
	);
};

export const corPontoPresenca = (status) => {
	switch (status) {
		case "online":
			return "#00a884";
		case "away":
			return "#f5a623";
		case "break":
			return "#f97316";
		case "lunch":
			return "#3b82f6";
		case "meeting":
			return "#ef4444";
		case "offline":
		default:
			return "#9ca3af";
	}
};

export const rotuloPresenca = (status) => {
	switch (status) {
		case "online":
			return "online";
		case "away":
			return "ausente";
		case "break":
			return "em pausa";
		case "lunch":
			return "almoço";
		case "meeting":
			return "em reunião";
		case "offline":
		default:
			return "offline";
	}
};
